import { AppContent } from '../AppContent';
import { MetaContentValues } from '../metaContentValues';

const rentIncreases: AppContent['rentIncreases'] = {
  metaContent: {
    title: MetaContentValues.rentIncreases.title,
  },
  backLabel: 'Back to Landlord support',
  title: 'Rent increases - England',
  description:
    "You'll more than likely need to increase the rent on your property at some point. But it's important to know how to do it properly, so your tenants know where they stand and you're not at risk of legal action.",

  periodicTenancy: {
    title: 'If your tenants have a periodic tenancy',
    description:
      'This could be weekly or monthly rolling tenancy agreements, for example. You can usually only increase the rent amount once a year with these types of agreements.',
  },

  fixedTermTenancy: {
    title: 'If your tenants have a fixed-term tenancy',
    includedACondition:
      "Unless you've included a condition about increasing the rent during the fixed-term period, you can only increase the rent amount once the fixed-term period has ended. If you have included a condition about rent increases, you must stick to what you've agreed.",
    realisticRentIncrease:
      'Any rent increase must be fair, realistic, and in line with market rents.',
  },

  rentIncreaseRequirements: {
    youMust: 'You must:',
    listItem1: "Give your tenants at least one month's notice.",
    listItem2:
      'Agree a rent increase with them in writing signed by you and them.',
    complete: 'Complete ',
    formLinkLabel: "Form 4: Landlord's notice proposing a new rent",
    formLinkHref: 'https://www.gov.uk/guidance/assured-tenancy-forms',
    period: '.',
  },

  disagreement: {
    title: "What if my tenants don't agree with the rent increase?",
    haveAConversation:
      'The best thing to do is have a conversation with them about it, so they can understand your reasons for increasing their rent. If they want to take it further after that, they can ask the ',
    tribunalLinkLabel: 'First Tier Property Tribunal',
    tribunalLinkHref:
      'https://www.gov.uk/housing-tribunals/apply-to-the-tribunal',
    decideRightAmount: ' to decide the right amount of rent.',
  },

  walesAccordion: {
    label: 'Rent increases - Wales',
    needAComplete: "You'll need to complete a ",
    noticeOfVariationLinkLabel: 'Notice of variation of rent: form RHW12',
    noticeOfVariationLinkHref:
      'https://www.gov.wales/notice-variation-rent-form-rhw12',
    postToTenants: ' and post or email it your tenants.',
    fixedTermContract:
      "If your tenant has a fixed-term contract, you can't increase their rent during the contract. Once it's ended, or they don't have a fixed-term contract, you can increase it once in a 12-month period. You'll have to give at least two months' written notice beforehand.",
    howMuchCanIIncreaseTitle: 'How much can I increase it by?',
    noLegalLimit:
      "There's no legal limit for how much you can increase your rent by. And tenants can't challenge it. Of course, this might change in the future.",
  },

  scotlandAccordion: {
    label: 'Rent increases - Scotland',
    privateTenancy:
      "If your tenant has a private residential tenancy, you'll need to use a ",
    rentIncreaseNoticeLinkLabel: 'Rent Increase Notice',
    rentIncreaseNoticeLinkHref:
      'https://www.mygov.scot/create-rent-increase-notice#!/tenancy/start-date',
    cantUseForOtherTenancy:
      ". You can't use this for any other kind of tenancy. You must also give tenants three months' notice to increase their rent.",
    jointTenancy:
      "If your tenants have a joint tenancy agreement, you only need to give one Rent Increase Notice. Where each tenant has their own tenancy agreement, you'll need to give a Rent Increase Notice to them individually.",
    scottishGovernment:
      'The Scottish Government has placed an absolute cap on rent rises of 12%, which tapers down depending on how much rents on new tenancies have increased in the local area.',
    challengeRentIncreases:
      'Tenants in Scotland can challenge rent increases through ',
    rentServiceLinkLabel: 'Rent Service Scotland',
    rentServiceLinkHref: 'https://www.mygov.scot/create-rent-increase-referral',
    applyToRentService:
      '. They must apply to Rent Service Scotland within 21 days of receiving your Rent Increase Notice. A decision is usually made within 40 days and is binding.',
  },

  northernIrelandAccordion: {
    label: 'Rent increases - Northern Ireland',
    fixedTermTitle: 'If your tenant has a fixed-term tenancy',
    fixedTermDescription:
      'Rent can only be increased during the fixed-term period if the tenancy agreement includes a rent review clause and if the tenant agrees to the increase.',
    periodicTitle: 'If your tenant has a periodic tenancy',
    periodicDescription:
      "For week-by-week or month-by-month rolling tenancies, rent can typically be increased once a year. You must provide at least one month's written notice.",
    rentControlledTitle: 'If your tenancy is rent controlled',
    rentControlledDescription:
      "If this is the case, the maximum rent you can charge is decided by a Rent Officer. Both you and the tenant will be told how much this is. If you or the tenant don't agree, you have 14 days to appeal.",
    rentControlLinkLabel: 'How does rent control work?',
    rentControlLinkHref:
      'https://www.nidirect.gov.uk/articles/how-rent-control-worked-out',
  },
};

export default rentIncreases;
